if (!customElements.get('ly-scenes-v2')) {
  customElements.define('ly-scenes-v2', class extends LyVariableScrollCarousel {

    #media = window.matchMedia('(max-width: 767px)')

    itemBtns = []
    popperBtns = []
    expandBtns = []

    btnToItem = new WeakMap()
    itemToBtn = new WeakMap()

    popperBtnToItem = new WeakMap()
    expandBtnToItem = new WeakMap()

    itemToPopper = new WeakMap()
    itemToExpand = new WeakMap()

    popperToBtn = new WeakMap()
    expandToBtn = new WeakMap()

    activedExtensions = new Set()
    activedExtensionsDetail = new WeakMap()

    connectedCallback() {
      super.connectedCallback()

      this.init()

      this.addClickEvents()

      this.#media.addEventListener('change', this.handleMediaChange)
    }

    disconnectedCallback() {
      this.removeClickEvents()

      this.#media.removeEventListener('change', this.handleMediaChange)

      super.disconnectedCallback()
    }

    init = () => {
      this._items.forEach(item => {
        const btn = item.querySelector('[data-action-btn][data-item]')
        const popperBtn = item.querySelector('[data-action-btn][data-popper]')
        const expandBtn = item.querySelector('[data-action-btn][data-expand]')
        const popper = item.querySelector('[data-popper]')
        const expand = item.querySelector('[data-expand]')

        this.itemBtns.push(btn)
        this.popperBtns.push(popperBtn)
        this.expandBtns.push(expandBtn)

        this.btnToItem.set(btn, item)
        this.itemToBtn.set(item, btn)

        this.popperBtnToItem.set(popperBtn, item)
        this.expandBtnToItem.set(expandBtn, item)

        this.itemToPopper.set(item, popper)
        this.itemToExpand.set(item, expand)

        this.popperToBtn.set(popper, popperBtn)
        this.expandToBtn.set(expand, expandBtn)
      })
    }

    addClickEvents = () => {
      this.itemBtns.forEach(btn => {
        btn.addEventListener('click', this.handleClick)
      })
      this.popperBtns.forEach(btn => {
        btn.addEventListener('click', this.handleClosePopper)
      })
      this.expandBtns.forEach(btn => {
        btn.addEventListener('click', this.handleCloseExpand)
      })
    }

    removeClickEvents = () => {
      this.itemBtns.forEach(btn => {
        btn.removeEventListener('click', this.handleClick)
      })
      this.popperBtns.forEach(btn => {
        btn.removeEventListener('click', this.handleClosePopper)
      })
      this.expandBtns.forEach(btn => {
        btn.removeEventListener('click', this.handleCloseExpand)
      })
    }

    handleClick = async (evt) => {
      const btn = evt.currentTarget
      const item = this.btnToItem.get(btn)

      item.classList.add('is-actived')
      btn.classList.add('is-actived')

      await this.wait(50)

      const extension = this.#media.matches ? this.itemToPopper.get(item) : this.itemToExpand.get(item)
      const extensionBtn = this.#media.matches ? this.popperToBtn.get(extension) : this.expandToBtn.get(extension)

      this.activeExtension(extension, extensionBtn, item, btn)
    }

    handleClosePopper = async (evt) => {
      const popperBtn = evt.currentTarget
      const item = this.popperBtnToItem.get(popperBtn)
      const popper = this.itemToPopper.get(item)
      const btn = this.itemToBtn.get(item)

      this.unactiveExtension(popperBtn, popper, item, btn)
    }

    handleCloseExpand = async (evt) => {
      const expandBtn = evt.currentTarget
      const item = this.expandBtnToItem.get(expandBtn)
      const expand = this.itemToExpand.get(item)
      const btn = this.itemToBtn.get(item)

      this.unactiveExtension(expandBtn, expand, item, btn)
    }

    activeExtension = async (e, eBtn, item, btn) => {

      e.classList.add('is-actived')

      this.activedExtensions.add(e)
      this.activedExtensionsDetail.set(e, {
        e, eBtn, item, btn
      })

      await this.wait(150)

      eBtn.classList.add('is-actived')
    }

    unactiveExtension = async (eBtn, e, item, btn) => {

      eBtn.classList.remove('is-actived')

      this.activedExtensions.delete(e)
      this.activedExtensionsDetail.delete(e)

      await this.wait(50)

      e.classList.remove('is-actived')

      await this.wait(150)

      item.classList.remove('is-actived')
      btn.classList.remove('is-actived')
    }

    wait = (t = 0) => new Promise(resolve => setTimeout(resolve, t))

    handleMediaChange = () => {
      this.activedExtensions.forEach(e => {
        const detail = this.activedExtensionsDetail.get(e)
        const { eBtn, item, btn } = detail
        this.unactiveExtension(eBtn, e, item, btn)
      })
    }

  })
}